module.exports = __webpack_public_path__ + "static/media/keycdn.f5a2a1be.svg";